/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { BannedBulkCreateResponseDTOFromJSON, BannedItemBulkCopyDTOToJSON, BannedItemBulkCreateDTOToJSON, BannedItemBulkDeleteDTOToJSON, CommonBannedAsinBulkCopyDTOToJSON, CommonBannedAsinBulkCopyResponseDTOFromJSON, PaginatedResponseBannedItemResponseDTOFromJSON, PaginatedResponseCommonBannedAsinResponseDTOFromJSON, } from '../models/index';
/**
 *
 */
export class BannedItemsControllerApi extends runtime.BaseAPI {
    /**
     */
    async addAsinsBulkRaw(requestParameters, initOverrides) {
        if (requestParameters['bannedItemBulkCreateDTO'] == null) {
            throw new runtime.RequiredError('bannedItemBulkCreateDTO', 'Required parameter "bannedItemBulkCreateDTO" was null or undefined when calling addAsinsBulk().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/asins/bulk`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BannedItemBulkCreateDTOToJSON(requestParameters['bannedItemBulkCreateDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BannedBulkCreateResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async addAsinsBulk(requestParameters, initOverrides) {
        const response = await this.addAsinsBulkRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async addBrandsBulkRaw(requestParameters, initOverrides) {
        if (requestParameters['bannedItemBulkCreateDTO'] == null) {
            throw new runtime.RequiredError('bannedItemBulkCreateDTO', 'Required parameter "bannedItemBulkCreateDTO" was null or undefined when calling addBrandsBulk().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/brands/bulk`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BannedItemBulkCreateDTOToJSON(requestParameters['bannedItemBulkCreateDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BannedBulkCreateResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async addBrandsBulk(requestParameters, initOverrides) {
        const response = await this.addBrandsBulkRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async addCategoriesBulkRaw(requestParameters, initOverrides) {
        if (requestParameters['bannedItemBulkCreateDTO'] == null) {
            throw new runtime.RequiredError('bannedItemBulkCreateDTO', 'Required parameter "bannedItemBulkCreateDTO" was null or undefined when calling addCategoriesBulk().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/categories/bulk`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BannedItemBulkCreateDTOToJSON(requestParameters['bannedItemBulkCreateDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BannedBulkCreateResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async addCategoriesBulk(requestParameters, initOverrides) {
        const response = await this.addCategoriesBulkRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async addCommonCategoriesBulkRaw(requestParameters, initOverrides) {
        if (requestParameters['bannedItemBulkCreateDTO'] == null) {
            throw new runtime.RequiredError('bannedItemBulkCreateDTO', 'Required parameter "bannedItemBulkCreateDTO" was null or undefined when calling addCommonCategoriesBulk().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/common/categories/bulk`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BannedItemBulkCreateDTOToJSON(requestParameters['bannedItemBulkCreateDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BannedBulkCreateResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async addCommonCategoriesBulk(requestParameters, initOverrides) {
        const response = await this.addCommonCategoriesBulkRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async addKeywordsBulkRaw(requestParameters, initOverrides) {
        if (requestParameters['bannedItemBulkCreateDTO'] == null) {
            throw new runtime.RequiredError('bannedItemBulkCreateDTO', 'Required parameter "bannedItemBulkCreateDTO" was null or undefined when calling addKeywordsBulk().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/keywords/bulk`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BannedItemBulkCreateDTOToJSON(requestParameters['bannedItemBulkCreateDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BannedBulkCreateResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async addKeywordsBulk(requestParameters, initOverrides) {
        const response = await this.addKeywordsBulkRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async copyAsinsBulkRaw(requestParameters, initOverrides) {
        if (requestParameters['bannedItemBulkCopyDTO'] == null) {
            throw new runtime.RequiredError('bannedItemBulkCopyDTO', 'Required parameter "bannedItemBulkCopyDTO" was null or undefined when calling copyAsinsBulk().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/asins/bulk/copy`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BannedItemBulkCopyDTOToJSON(requestParameters['bannedItemBulkCopyDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BannedBulkCreateResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async copyAsinsBulk(requestParameters, initOverrides) {
        const response = await this.copyAsinsBulkRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async copyBrandsBulkRaw(requestParameters, initOverrides) {
        if (requestParameters['bannedItemBulkCopyDTO'] == null) {
            throw new runtime.RequiredError('bannedItemBulkCopyDTO', 'Required parameter "bannedItemBulkCopyDTO" was null or undefined when calling copyBrandsBulk().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/brands/bulk/copy`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BannedItemBulkCopyDTOToJSON(requestParameters['bannedItemBulkCopyDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BannedBulkCreateResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async copyBrandsBulk(requestParameters, initOverrides) {
        const response = await this.copyBrandsBulkRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async copyCategoriesBulkRaw(requestParameters, initOverrides) {
        if (requestParameters['bannedItemBulkCopyDTO'] == null) {
            throw new runtime.RequiredError('bannedItemBulkCopyDTO', 'Required parameter "bannedItemBulkCopyDTO" was null or undefined when calling copyCategoriesBulk().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/categories/bulk/copy`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BannedItemBulkCopyDTOToJSON(requestParameters['bannedItemBulkCopyDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BannedBulkCreateResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async copyCategoriesBulk(requestParameters, initOverrides) {
        const response = await this.copyCategoriesBulkRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async copyCommonAsinsBulkRaw(requestParameters, initOverrides) {
        if (requestParameters['commonBannedAsinBulkCopyDTO'] == null) {
            throw new runtime.RequiredError('commonBannedAsinBulkCopyDTO', 'Required parameter "commonBannedAsinBulkCopyDTO" was null or undefined when calling copyCommonAsinsBulk().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/common/asins/bulk/copy`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CommonBannedAsinBulkCopyDTOToJSON(requestParameters['commonBannedAsinBulkCopyDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => CommonBannedAsinBulkCopyResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async copyCommonAsinsBulk(requestParameters, initOverrides) {
        const response = await this.copyCommonAsinsBulkRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async copyCommonBrandsBulkRaw(requestParameters, initOverrides) {
        if (requestParameters['bannedItemBulkCopyDTO'] == null) {
            throw new runtime.RequiredError('bannedItemBulkCopyDTO', 'Required parameter "bannedItemBulkCopyDTO" was null or undefined when calling copyCommonBrandsBulk().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/common/brands/bulk/copy`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BannedItemBulkCopyDTOToJSON(requestParameters['bannedItemBulkCopyDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BannedBulkCreateResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async copyCommonBrandsBulk(requestParameters, initOverrides) {
        const response = await this.copyCommonBrandsBulkRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async copyCommonCategoriesBulkRaw(requestParameters, initOverrides) {
        if (requestParameters['bannedItemBulkCopyDTO'] == null) {
            throw new runtime.RequiredError('bannedItemBulkCopyDTO', 'Required parameter "bannedItemBulkCopyDTO" was null or undefined when calling copyCommonCategoriesBulk().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/common/categories/bulk/copy`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BannedItemBulkCopyDTOToJSON(requestParameters['bannedItemBulkCopyDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BannedBulkCreateResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async copyCommonCategoriesBulk(requestParameters, initOverrides) {
        const response = await this.copyCommonCategoriesBulkRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async copyCommonKeywordsBulkRaw(requestParameters, initOverrides) {
        if (requestParameters['bannedItemBulkCopyDTO'] == null) {
            throw new runtime.RequiredError('bannedItemBulkCopyDTO', 'Required parameter "bannedItemBulkCopyDTO" was null or undefined when calling copyCommonKeywordsBulk().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/common/keywords/bulk/copy`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BannedItemBulkCopyDTOToJSON(requestParameters['bannedItemBulkCopyDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BannedBulkCreateResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async copyCommonKeywordsBulk(requestParameters, initOverrides) {
        const response = await this.copyCommonKeywordsBulkRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async copyKeywordsBulkRaw(requestParameters, initOverrides) {
        if (requestParameters['bannedItemBulkCopyDTO'] == null) {
            throw new runtime.RequiredError('bannedItemBulkCopyDTO', 'Required parameter "bannedItemBulkCopyDTO" was null or undefined when calling copyKeywordsBulk().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/keywords/bulk/copy`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BannedItemBulkCopyDTOToJSON(requestParameters['bannedItemBulkCopyDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BannedBulkCreateResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async copyKeywordsBulk(requestParameters, initOverrides) {
        const response = await this.copyKeywordsBulkRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteAsinsBulkRaw(requestParameters, initOverrides) {
        if (requestParameters['bannedItemBulkDeleteDTO'] == null) {
            throw new runtime.RequiredError('bannedItemBulkDeleteDTO', 'Required parameter "bannedItemBulkDeleteDTO" was null or undefined when calling deleteAsinsBulk().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/asins/bulk`;
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: BannedItemBulkDeleteDTOToJSON(requestParameters['bannedItemBulkDeleteDTO']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteAsinsBulk(requestParameters, initOverrides) {
        await this.deleteAsinsBulkRaw(requestParameters, initOverrides);
    }
    /**
     */
    async deleteBrandsBulkRaw(requestParameters, initOverrides) {
        if (requestParameters['bannedItemBulkDeleteDTO'] == null) {
            throw new runtime.RequiredError('bannedItemBulkDeleteDTO', 'Required parameter "bannedItemBulkDeleteDTO" was null or undefined when calling deleteBrandsBulk().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/brands/bulk`;
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: BannedItemBulkDeleteDTOToJSON(requestParameters['bannedItemBulkDeleteDTO']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteBrandsBulk(requestParameters, initOverrides) {
        await this.deleteBrandsBulkRaw(requestParameters, initOverrides);
    }
    /**
     */
    async deleteCategoriesBulkRaw(requestParameters, initOverrides) {
        if (requestParameters['bannedItemBulkDeleteDTO'] == null) {
            throw new runtime.RequiredError('bannedItemBulkDeleteDTO', 'Required parameter "bannedItemBulkDeleteDTO" was null or undefined when calling deleteCategoriesBulk().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/categories/bulk`;
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: BannedItemBulkDeleteDTOToJSON(requestParameters['bannedItemBulkDeleteDTO']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteCategoriesBulk(requestParameters, initOverrides) {
        await this.deleteCategoriesBulkRaw(requestParameters, initOverrides);
    }
    /**
     */
    async deleteCommonCategoriesBulkRaw(requestParameters, initOverrides) {
        if (requestParameters['bannedItemBulkDeleteDTO'] == null) {
            throw new runtime.RequiredError('bannedItemBulkDeleteDTO', 'Required parameter "bannedItemBulkDeleteDTO" was null or undefined when calling deleteCommonCategoriesBulk().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/common/categories/bulk`;
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: BannedItemBulkDeleteDTOToJSON(requestParameters['bannedItemBulkDeleteDTO']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteCommonCategoriesBulk(requestParameters, initOverrides) {
        await this.deleteCommonCategoriesBulkRaw(requestParameters, initOverrides);
    }
    /**
     */
    async deleteKeywordsBulkRaw(requestParameters, initOverrides) {
        if (requestParameters['bannedItemBulkDeleteDTO'] == null) {
            throw new runtime.RequiredError('bannedItemBulkDeleteDTO', 'Required parameter "bannedItemBulkDeleteDTO" was null or undefined when calling deleteKeywordsBulk().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/keywords/bulk`;
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: BannedItemBulkDeleteDTOToJSON(requestParameters['bannedItemBulkDeleteDTO']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteKeywordsBulk(requestParameters, initOverrides) {
        await this.deleteKeywordsBulkRaw(requestParameters, initOverrides);
    }
    /**
     */
    async exportBannedListRaw(requestParameters, initOverrides) {
        if (requestParameters['kind'] == null) {
            throw new runtime.RequiredError('kind', 'Required parameter "kind" was null or undefined when calling exportBannedList().');
        }
        const queryParameters = {};
        if (requestParameters['marketplaces'] != null) {
            queryParameters['marketplaces'] = requestParameters['marketplaces'];
        }
        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }
        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/{kind}/export`;
        urlPath = urlPath.replace(`{${"kind"}}`, encodeURIComponent(String(requestParameters['kind'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async exportBannedList(requestParameters, initOverrides) {
        const response = await this.exportBannedListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async listAsinsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        if (requestParameters['marketplaces'] != null) {
            queryParameters['marketplaces'] = requestParameters['marketplaces'];
        }
        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }
        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/asins`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResponseBannedItemResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async listAsins(requestParameters = {}, initOverrides) {
        const response = await this.listAsinsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async listBrandsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        if (requestParameters['marketplaces'] != null) {
            queryParameters['marketplaces'] = requestParameters['marketplaces'];
        }
        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }
        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/brands`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResponseBannedItemResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async listBrands(requestParameters = {}, initOverrides) {
        const response = await this.listBrandsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async listCategoriesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        if (requestParameters['marketplaces'] != null) {
            queryParameters['marketplaces'] = requestParameters['marketplaces'];
        }
        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }
        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/categories`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResponseBannedItemResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async listCategories(requestParameters = {}, initOverrides) {
        const response = await this.listCategoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async listCommonAsinsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        if (requestParameters['marketplaces'] != null) {
            queryParameters['marketplaces'] = requestParameters['marketplaces'];
        }
        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }
        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/common/asins`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResponseCommonBannedAsinResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async listCommonAsins(requestParameters = {}, initOverrides) {
        const response = await this.listCommonAsinsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async listCommonBrandsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        if (requestParameters['marketplaces'] != null) {
            queryParameters['marketplaces'] = requestParameters['marketplaces'];
        }
        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }
        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/common/brands`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResponseBannedItemResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async listCommonBrands(requestParameters = {}, initOverrides) {
        const response = await this.listCommonBrandsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async listCommonCategoriesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        if (requestParameters['marketplaces'] != null) {
            queryParameters['marketplaces'] = requestParameters['marketplaces'];
        }
        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }
        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/common/categories`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResponseBannedItemResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async listCommonCategories(requestParameters = {}, initOverrides) {
        const response = await this.listCommonCategoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async listCommonKeywordsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        if (requestParameters['marketplaces'] != null) {
            queryParameters['marketplaces'] = requestParameters['marketplaces'];
        }
        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }
        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/common/keywords`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResponseBannedItemResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async listCommonKeywords(requestParameters = {}, initOverrides) {
        const response = await this.listCommonKeywordsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async listKeywordsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }
        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }
        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }
        if (requestParameters['marketplaces'] != null) {
            queryParameters['marketplaces'] = requestParameters['marketplaces'];
        }
        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }
        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/user/banned/keywords`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResponseBannedItemResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async listKeywords(requestParameters = {}, initOverrides) {
        const response = await this.listKeywordsRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
